import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { Empresa } from '../../../models/empresa';
const API_URL = environment.apiUrl;


@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('RegiaoService');
  }

  obterTodos(param: any): Observable<any> {
    const params = new HttpParams()
      .set('pageNumber', `${param.offset}`)
      .set('pageSize', `${param.limit}`)
      .set('estado', `${param.estado == null ? '' : param.estado}`)
      .set('descricao', `${param.descricao}`)
      .set('ativo', `${param.ativo}`);

    return this.http.get<any>(API_URL + "company", { params })
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }

  obterTodosRegistroDeContato(param: any): Observable<any> {
    const params = new HttpParams()
      .set('pageNumber', `${param.offset}`)
      .set('pageSize', `${param.limit}`)
      .set('estado', `${param.estado == null ? '' : param.estado}`)
      .set('descricao', `${param.descricao}`)
      .set('id', `${param.id}`);

    return this.http.get<any>(API_URL + "registercontact", { params })
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }

  estados(descricao: string): Observable<any> {
    return this.http.get<any>(API_URL + "state")
      .pipe(
        catchError(this.handleError('ListarEstados', []))
      );
  }

  listSegments(descricao: string): Observable<any> {
    return this.http.get<any>(API_URL + "segment")
      .pipe(
        catchError(this.handleError('segment', []))
      );
  }
  atualizarEmpresa(empresa: Empresa): Observable<any> {
    return this.http.put<Empresa>(API_URL + "company/", empresa)
      .pipe(
        catchError(this.handleError('company', empresa))
      );
  }
  alterarSenha(record: any): Observable<any> {
    return this.http.put<any>(API_URL + "company/changepassword", record)
      .pipe(
        catchError(this.handleError('changepassword', record))
      );
  }

  obterPorCodigo(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "company/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }
  obterInformacoesEmpresa(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "company/infoCompany/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }
  inserirRegistroDeContato(item: any): Observable<any> {
    return this.http.post<any>(API_URL + "registercontact", item)
      .pipe(
        catchError(this.handleError('inserirRegistroDeContato', item))
      );
  }
  atualizarRegistroDeContato(item: any): Observable<any> {
    return this.http.put<any>(API_URL + "registercontact", item)
      .pipe(
        catchError(this.handleError('atualizarRegistroDeContato', item))
      );
  }

  obterPorCodigoRegistroDeContato(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "registercontact/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }

  alterarAcessoPainelWeb(id: number): Observable<any> {
    return this.http.put<any>(API_URL + "company/painelweb", { id: id })
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }


  AtivarOuInativar(ids: any): Observable<any> {
    return this.http.post<any>(API_URL + "empresa/AtivarOuInativar/", ids)
      .pipe(
        catchError(this.handleError('ativarOuInativar', ids))
      );
  }

  ListarEstados(descricao: string): Observable<any> {

    return this.http.get<any>(API_URL + "empresa/ListarEstados?descricao=" + descricao)
      .pipe(
        catchError(this.handleError('ListarEstados', []))
      );
  }

  ListarUsuarios(descricao: string, codEmpresa: number): Observable<any> {
    const params = new HttpParams()
      .set('descricao', `${descricao}`)
      .set('codigoEmpresa', `${codEmpresa}`);
    return this.http.get<any>(API_URL + "empresa/ListarUsuarios", { params })
      .pipe(
        catchError(this.handleError('ListarUsuarios', []))
      );
  }

  listarCidades(codigo: number, descricao: string): Observable<any> {
    const params = new HttpParams()
      .set('descricao', `${descricao}`)
      .set('Codigo', `${codigo}`);
    return this.http.get<any>(API_URL + "empresa/ListarCidade", { params })
      .pipe(
        catchError(this.handleError('ListarCidade', []))
      );
  }

  ListarFormaPagamento(descricao: string): Observable<any> {

    return this.http.get<any>(API_URL + "empresa/ListarFormaPagamento/descricao=" + descricao)
      .pipe(
        catchError(this.handleError('ListarFormaPagamento', []))
      );
  }

  ListarTipoFaturamento(descricao: string): Observable<any> {
    return this.http.get<any>(API_URL + "empresa/ListarTipoFaturamento/descricao=" + descricao)
      .pipe(
        catchError(this.handleError('ListarFormaPagamento', []))
      );
  }

  ListarPerfilPagamento(descricao: string): Observable<any> {
    return this.http.get<any>(API_URL + "empresa/ListarPerfil/descricao=" + descricao)
      .pipe(
        catchError(this.handleError('ListarPerfil', []))
      );
  }

  ListarCondicaoPagamento(descricao: string): Observable<any> {
    return this.http.get<any>(API_URL + "empresa/ListarCondicaoPagamento/descricao=" + descricao)
      .pipe(
        catchError(this.handleError('ListarCondicaoPagamento', []))
      );
  }

  ObterComboVendedor(descricao: string): Observable<any> {
    return this.http.get<any>(API_URL + "empresa/ObterVendedoresCombo?descricao=" + descricao)
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }

  vincularVendedorEmpresa(codigoVendedor: number, codigoEmpresa: number): Observable<any> {
    let params = {
      codigoVendedor,
      codigoEmpresa
    }
    return this.http.post(API_URL + "empresa/VincularVendedorEmpresa", params)
      .pipe(
        catchError(this.handleError('vincularEmpresa', []))
      );
  }

  inserirOuAtualizar(empresa: Empresa): Observable<any> {
    return this.http.post<Empresa>(API_URL + "empresa/", empresa)
      .pipe(
        catchError(this.handleError('inserirOuAtualizar', empresa))
      );
  }



  salvarInformacoesReceita(record: any): Observable<any> {
    return this.http.put<any>(API_URL + "company/receitafederal", record)
      .pipe(
        catchError(this.handleError('receitafederal', record))
      );
  }

  obterInformacoesReceita(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "company/receitafederal/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }
  atualizarInformacoesReceitaFederal(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "company/receitafederal/validateautomatic/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }

  registarEmpresaComoInvalida(record: any): Observable<any> {
    return this.http.put<any>(API_URL + "company/receitafederal/registerinvalidcompany", record)
    .pipe(
      catchError(this.handleError('receitafederal', record))
    );
  }
}
